import { render } from "./CreateNewBuyer.vue?vue&type=template&id=34204610&scoped=true"
import script from "./CreateNewBuyer.vue?vue&type=script&lang=js"
export * from "./CreateNewBuyer.vue?vue&type=script&lang=js"

import "./CreateNewBuyer.vue?vue&type=style&index=0&id=34204610&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34204610"]])

export default __exports__